export class DadosVestibular {
  vestibular: any;
  cursoSelecionado: any;
  candidato: any;
  agendamento: any;
  pagamento: any;
  polo: any;
  enem: any;
  valorVestibular: any;
  valorCurso: any;
  siglaVestibular:any;
  provaOnline: any;
  contexto: any;

  constructor(args) {
    Object.assign(this, args);
  }
}

export class InscricaoResponse {
  numeroInscricao: string;
  agendamento: {
    predio: string,
    sala: string,
  };
  valorVestibular: any;

  constructor(args) {
    Object.assign(this, args);
  }
}
